import { CalendarOutlined } from '@ant-design/icons';
import { Alert, Card, Col, Row } from 'antd';
import Title from 'antd/lib/typography/Title';
import { Maybe } from 'graphql/jsutils/Maybe';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { extractTranslation, formatPortalFacilityPath } from '../../helpers/formatters';
import { getAppointmentTypeName } from '../../helpers/utils';
import { Patientportal_AppointmentRequestProxyMsg } from '../../src/generated/graphql';
import styles from '../appointment-details/appointment-details.module.scss';
import { DateRangeFormatter } from '../common-layout/date-range-formatter';

interface AppointmentRequestHeaderProps {
  appointmentRequestProxy: Maybe<Patientportal_AppointmentRequestProxyMsg> | undefined;
  title?: string;
}

export const AppointmentRequestHeader: FC<AppointmentRequestHeaderProps> = ({
  appointmentRequestProxy,
  title,
}) => {
  const { formatMessage } = useIntl();

  const router = useRouter();

  const appointmentRequest = appointmentRequestProxy?.appointmentRequest;

  const appointmentType = appointmentRequest?.appointmentType;
  const portalFacilities = appointmentRequestProxy?.portalFacilityPath?.portalFacilities;

  const exactSlot = appointmentRequest?.requestPreferences?.exactTimeSlot;
  const insideTimeFrame = appointmentRequest?.requestPreferences?.insideTimeFrame;

  const unverified = appointmentRequest?.unverified;

  return (
    <Card>
      <Title>
        {title ||
          formatMessage(
            { id: 'appointment-request.title' },
            {
              appointmentType:
                extractTranslation(getAppointmentTypeName(appointmentType), router.locale) || '-',
            },
          )}
      </Title>
      <Row>
        <Col span={24}>
          <div className={styles.calendarDiv}>
            <CalendarOutlined />
          </div>
          <div className={styles.portalFacilityPath}>
            <Row>
              <Col span={24}>{formatPortalFacilityPath(portalFacilities, true)}</Col>
            </Row>
            {exactSlot && <DateRangeFormatter start={exactSlot?.start} />}
            {insideTimeFrame && (
              <DateRangeFormatter start={insideTimeFrame?.start} end={insideTimeFrame.end} />
            )}
          </div>
        </Col>
      </Row>
      {unverified && (
        <Alert
          style={{
            marginTop: 22,
            backgroundColor: 'rgba(160,68,68,0.3)',
            color: 'white',
          }}
          type={'error'}
          message={formatMessage({
            id: 'appointment-request.not-verified.description',
          })}
        />
      )}
    </Card>
  );
};
